import { useCallback, useEffect, useState } from 'react';

import useDelayFn from '~hooks/useDelayFn';
import { AssetId } from '~modules/media-library/model/Asset';
import { RaiseRequestModal } from '~modules/media-library/view/RaiseRequestForm/RaiseRequestModal';

export function RaiseRequestModalController({ assetId, onClose }: { assetId: AssetId; onClose: () => void }) {
  const delayedOnClose = useDelayFn(onClose, 500);
  const [isOpen, setIsOpen] = useState(false);

  // open modal when settings are loaded
  useEffect(() => {
    setIsOpen(Boolean(assetId));
  }, [assetId]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    delayedOnClose();
  }, [delayedOnClose]);

  return <RaiseRequestModal isOpen={isOpen} onClose={handleOnClose} assetId={assetId} />;
}
